export const MIN_SUB_BRANDS_FOR_SELECTION = 2;
